import { useSelector } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { AppState } from '../../../../types/store';
import { ModuleType } from '../../../../types/modules';
import { getModuleDataByModuleType } from '../../../selectors/modules';

export const useTiersModuleCounts = () => {
  // SUBSCRIPTION_TIPS module does not contain all the neccessary data
  // so we have to fetch it from the TIERS module
  const moduleData = useSelector((state: AppState) =>
    getModuleDataByModuleType(state, ModuleType.TIERS)
  );
  const tiersIds = moduleData?.tiers || [];
  const tiers = useSelector((state: AppState) =>
    getDeviationsByIds(state, tiersIds)
  );

  const publishedCount = tiers.filter(
    deviation => deviation.tier?.state === 'active'
  ).length;
  const subscriberCount = tiers.reduce(
    (total, deviation) => total + (deviation.tier?.stats?.subscribers || 0),
    0
  );
  const draftCount = tiers.filter(
    deviation => deviation.tier?.state === 'draft'
  ).length;

  return {
    draftCount,
    subscriberCount,
    publishedCount,
  };
};

export default useTiersModuleCounts;
